import script from "./userCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./userCard.vue?vue&type=script&lang=ts&setup=true"

import "./userCard.vue?vue&type=style&index=0&id=76af27b9&lang=scss&scoped=true"

import exportComponent from "/Users/niming/Documents/vue-mooc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76af27b9"]])

export default __exports__